import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { QuestionOption, QuestionType, RatingType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { IQuestionOptionForm } from './question-form-group.interface';
import { QuestionForm } from './question-form.model';
import { QuestionOptionForm } from './question-option-form.model';

const DEFAULT_RATING_SCALE = 1;

export class QuestionFormRankSort extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(index: number, pageId: string): void {
    super.initEmpty(index, pageId);
    this.form.get('type').setValue(QuestionType.RankSort);
    (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
    (this.form.get('ranks') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(null, 'rank_1').form);
  }

  init(question: Question): void {
    super.init(question);
    this.form.get('type').setValue(QuestionType.RankSort);
    this.patchOptions(question.options);

    if (!question.useOtherPosition) {
      const useOtherInd = this.form.get('useOtherInd').value;
      this.form.get('useOtherPosition').setValue(useOtherInd ? this.form.get('options').value.length : -1);
    }

    if (question.ratingType === RatingType.descriptive) {
      this.patchRanks(question.ranks);
    }
  }

  private extendFormGroup(): void {
    this.form.addControl('maxLength', new FormControl<number>(0));
    this.form.addControl('minLength', new FormControl<number>(1));
    this.form.addControl('randomizedOptionsInd', new FormControl<boolean>(false));
    this.form.addControl('options', new FormArray<FormGroup<IQuestionOptionForm>>([]));
    this.form.addControl('useOtherInd', new FormControl<boolean>(false));
    this.form.addControl('useOtherPosition', new FormControl<number>(-1));
    this.form.addControl('useOtherPinnedInd', new FormControl<boolean>(false));
    this.form.addControl('otherLabel', new FormControl<string>('Other, please specify'));
    this.form.addControl('useExclusiveOtherInd', new FormControl<boolean>(true));
    this.form.addControl('useNoneInd', new FormControl<boolean>(false));
    this.form.addControl('noneLabel', new FormControl<string>('None of these'));
    this.form.addControl('ratingType', new FormControl<RatingType>(RatingType.numeric));
    this.form.addControl('ratingScale', new FormControl<number>(DEFAULT_RATING_SCALE));
    this.form.addControl('ranks', new FormArray<FormGroup<IQuestionOptionForm>>([]));
    this.form.addControl('minRank', new FormControl<number>(1));
    this.form.addControl('feedbackMessage', new FormControl<string>(''));

    this.form.get('requiredInd').valueChanges.subscribe((requiredInd: boolean) => {
      if (requiredInd && this.form.get('minLength').value === 0) {
        this.form.get('minLength').setValue(1);
      }
    });
  }

  private patchOptions(options: QuestionOption[]): void {
    if (!options || options.length === 0) {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
      return;
    }
    options.forEach((option) => {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(option).form);
    });
  }

  private patchRanks(options: QuestionOption[]): void {
    if (!options || options.length === 0) {
      (this.form.get('ranks') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(null, 'rank_1').form);
      return;
    }
    options.forEach((option) => {
      (this.form.get('ranks') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(option).form);
    });
  }
}
